"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _pageLite = _interopRequireDefault(require("./page-lite"));
var _topicPageLite = _interopRequireDefault(require("./topic-page-lite"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var factories = {
  page_v2: _pageLite["default"],
  topicPage: _topicPageLite["default"]
};
var getItems = function getItems(items) {
  var all = items.map(function (item) {
    var _item$sys, _item$sys$contentType, _item$sys$contentType2;
    var contentType = item === null || item === void 0 ? void 0 : (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : (_item$sys$contentType = _item$sys.contentType) === null || _item$sys$contentType === void 0 ? void 0 : (_item$sys$contentType2 = _item$sys$contentType.sys) === null || _item$sys$contentType2 === void 0 ? void 0 : _item$sys$contentType2.id;
    var factory = factories[contentType];
    return factory ? factory(item) : null;
  });
  return all.filter(function (item) {
    return item;
  });
};
var createButtonCloud = function createButtonCloud(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    name: (0, _utils.getProp)(fields, 'name'),
    site: (0, _utils.getProp)(fields, 'site'),
    title: (0, _utils.getProp)(fields, 'title'),
    items: (0, _utils.getProp)(fields, 'items') ? getItems(fields.items) : null
  };
};
var _default = createButtonCloud;
exports["default"] = _default;